import isEmpty from "lodash/isEmpty";
import moment from "moment-timezone";

import {AccountUser} from "@/lib/types/accounts.ts";

export const isUserStaffAccount = (user?: AccountUser): boolean => {
  return user?.account.id === 1 || false;
};

export const isFreeTrialExpired = (user?: AccountUser): boolean => {
  const freeTrialExpires = user?.account?.free_trial_expires_at;
  return !isEmpty(freeTrialExpires) && moment(freeTrialExpires).isSameOrBefore(moment());
};
